/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SegmentUnlockCodeResponse
 */
export interface SegmentUnlockCodeResponse {
    /**
     * Zero-based index of the segment the code unlocks.
     * @type {number}
     * @memberof SegmentUnlockCodeResponse
     */
    segmentIndex: number;
    /**
     * Bulk partner unlock code for this segment. Resolved from `segments[i].prizePoolIds[0] → PrizePool → RewardConfig → PromoToken.couponCodes[0]`. Single shared string per segment; per-user single-use enforced by the partner's redemption page.
     * @type {string}
     * @memberof SegmentUnlockCodeResponse
     */
    unlockCode: string;
}

/**
 * Check if a given object implements the SegmentUnlockCodeResponse interface.
 */
export function instanceOfSegmentUnlockCodeResponse(value: object): value is SegmentUnlockCodeResponse {
    if (!('segmentIndex' in value) || value['segmentIndex'] === undefined) return false;
    if (!('unlockCode' in value) || value['unlockCode'] === undefined) return false;
    return true;
}

export function SegmentUnlockCodeResponseFromJSON(json: any): SegmentUnlockCodeResponse {
    return SegmentUnlockCodeResponseFromJSONTyped(json, false);
}

export function SegmentUnlockCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SegmentUnlockCodeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'segmentIndex': json['segmentIndex'],
        'unlockCode': json['unlockCode'],
    };
}

export function SegmentUnlockCodeResponseToJSON(json: any): SegmentUnlockCodeResponse {
    return SegmentUnlockCodeResponseToJSONTyped(json, false);
}

export function SegmentUnlockCodeResponseToJSONTyped(value?: SegmentUnlockCodeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'segmentIndex': value['segmentIndex'],
        'unlockCode': value['unlockCode'],
    };
}

